<template lang="html">
    <li class="main-menu__item">
        <router-link v-bind:to="{ name: 'Companies'}" v-bind:class="{[settingsLinkActiveClass]: (settingLink == 'Companies')}">
            <span>Компании</span>
        </router-link>
    </li>
</template>
<script>
    export default {
        name: 'companies-settings-menu',
        sort: 9,
        module: 'companies',
        data() {
            return {
            sort: 9,
            module: 'companies'
            }
        },
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }
        }        
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?10802c8c